import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'

import Modal from '../../components/UI/Modal/Modal'
import Question from '../../components/UI/Question/Question'
import Aux from '../../hoc/Aux/Aux'
import * as actions from '../../store/actions/index';
import Detail from "../UI/Detail/Detail";
import Button from "../UI/Button/Button";

class AuthRoute extends Component {

  publicList = ['/login', '/register', '/articles', '/', '/contact', '/physiotherapist']
  specialList = ['/getnewqrcode', '/getpdf', '/seeplan']

  getCookie = name => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  componentDidMount = async () => {
    const pathname = this.props.location.pathname.split("/")
    const firstPathname = "/" + pathname[1]
    // TODO: 404
    if (firstPathname === "/scan") {
      const search = this.props.location.search
      const index1 = search.indexOf("=")
      const index2 = search.indexOf("&")
      const code = search.substring(index1+1, index2)
      const user = await axios.post('https://backend.voin-cn.com/scan',
          {code: code})
      if (user.data.code === 0) {
        this.props.onAuthenticate(user.data, true, 0, "", user.data.doc.admin)
        this.props.history.push('/')
      } else if (user.data.code === 1) {
        this.props.onAuthenticate(user.data, false, 2, user.data.msg)
        this.props.onRemoveCookies()
        this.props.history.push('/')
      }
    } else if (firstPathname === "/bind"){
      const search = this.props.location.search
      const index1 = search.indexOf("=")
      const index2 = search.indexOf("&")
      const doctorId = search.substring(index1+1, index2)
      const codeSearch = search.substring(index2+1)
      const index3 = codeSearch.indexOf("=")
      const index4 = codeSearch.indexOf("&")
      const code = codeSearch.substring(index3+1, index4)
      const user = await axios.post('https://backend.voin-cn.com/bind',
          {doctorId: doctorId, code: code})
      if (user.data.code === 0) {
        await this.login()
        this.props.onShowBindInfo(user.data.msg)
        this.props.history.push('/exercises')
      } else if (user.data.code === 1) {
        await this.login()
        this.props.history.push('/exercises')
      }
    } else if (this.specialList.indexOf(firstPathname) > -1){
      this.props.onAuthenticate({code: 1}, false, 0, "")
    } else {
      await this.login(firstPathname)
    }
  }

  login = async (firstPathname) => {
    try {
      const user = await axios.get('https://backend.voin-cn.com/info',
          {params: {userId: this.getCookie("userId"),
              token: this.getCookie("token")}})
      if (user.data.code === 0) {
        if (!user.data.doc) {
          this.props.onAuthenticate(user.data, false, 0, "")
          this.props.onRemoveCookies()
          this.props.history.push('/')
        } else {
          this.props.onAuthenticate(user.data, true, 0, "", user.data.doc.admin, user.data.refer)
          if (this.publicList.indexOf(firstPathname) === 0 || this.publicList.indexOf(firstPathname) === 1) {
            this.props.history.push('/')
          }
        }
      } else if (user.data.code === 2) {
        this.props.onAuthenticate(user.data, false, 0, "")
        this.props.onRemoveCookies()
        if (this.publicList.indexOf(firstPathname) === -1) {
          this.props.history.push('/login')
        }
      } else if (user.data.code === 1) {
        this.props.onAuthenticate(user.data, false, 2, user.data.msg)
        this.props.onRemoveCookies()
      }
    } catch (error) {
      console.log(error)
      this.props.onAuthenticate({code: 2}, false, 2, "内部服务器错误，请刷新")
      this.props.onRemoveCookies()
    }
  }

  render() {
    const condition = !this.props.vip && !this.props.approved && this.props.admin !== 1 && this.props.admin !== 4 && this.props.admin !== 5
    return (
      <Aux>
        {this.props.mode === 2 ? (
          <Modal show={this.props.mode === 2}>
            <Question>{this.props.error}</Question>
          </Modal>
        ) : condition ? <Modal show={condition}>
          <Question>该用户未购买会员，请关注微信公众号：VOIN，注册会员</Question>
          <div style={{textAlign: 'center'}}>
            <Button btnType="Success" clicked={
              () => {
                this.props.onLogout()
                this.props.history.push("/")
              }
            }>退出登录</Button>
          </div>
        </Modal> : null}
        {null}
        {this.props.showDetailModal ? (
          <Detail/>
        ) : null}
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    showDetailModal: state.detail.showDetailModal,
    mode: state.authRoute.mode,
    error: state.authRoute.error,
    approved: state.authRoute.approved,
    admin: state.authRoute.admin,
    vip: state.authRoute.vip
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAuthenticate: (info, login, mode, error, admin, refer) => dispatch(actions.authenticate(info, login, mode, error, admin, refer)),
    onShowBindInfo: (msg) => dispatch(actions.showBindInfo(msg)),
    onRemoveCookies: () => dispatch(actions.removeCookies()),
    onLogout: () => dispatch(actions.logout())
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AuthRoute))


// WEBPACK FOOTER //
// ./src/components/AuthRoute/AuthRoute.js